import gql from 'graphql-tag';

const GET_PRICESHEET = gql`
 query pricesheet($pricesheetId: String!) {
    pricesheet: getPricesheet(pricesheetId: $pricesheetId) {
      id,
      label,
      baseMarkup,
      scope,
      scopeId,
      products {
        price
        product {
          id,
          brand,
          inRutaCode,
          category,
          inRutaShortDescriptionSpanish,
          image,
          catalog,
          vendorPrice
        }
      }
    }
  }
`;

export default GET_PRICESHEET;
